import { ProductOperationResponse } from '@repo/accounts-types'
import { GenericOperationState } from '@repo/core'
import { RootState } from '../../../store/types'

export const operationsSelectorConfig = {
  operationsMasterListSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ProductOperationResponse | null> {
      return state.accounts.master.list.operations
    },
  },
}
